export default __webpack_public_path__ + "static/media/item1.4c391a3a.png";